import { render } from "./MaleUsers.vue?vue&type=template&id=1390f29f&scoped=true"
import script from "./MaleUsers.vue?vue&type=script&lang=js"
export * from "./MaleUsers.vue?vue&type=script&lang=js"

import "./MaleUsers.vue?vue&type=style&index=0&id=1390f29f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1390f29f"

export default script